module.exports = __webpack_public_path__ + "img/area_2.ce6ada6b.png";